import * as React from 'react'

import { inject, observer } from 'mobx-react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { ISharedSitePermit } from '~/client/graph'
import { SharedEntityActionTypes } from '~/client/src/shared/components/SharedEntityActions/SharedEntityActions'
import SharedPermitActions from '~/client/src/shared/components/SharedEntityActions/SharedPermitActions'
import SharedSitePermitStore from '~/client/src/shared/stores/domain/SharedSitePermit.store'

import MobileCommonStore from '../../stores/ui/MobileCommon.store'
import { EntitySharedView, defaultHandlers } from './EntitySharedView'

interface IProps {
  common: MobileCommonStore
  sharedSitePermitStore?: SharedSitePermitStore
}

interface IRouteParams {
  entityId: string
}

const FormsSharedView: React.FC<IProps & RouteComponentProps<IRouteParams>> = ({
  common,
  sharedSitePermitStore,
  match,
}) => {
  const handleActionClick = (
    actionType: SharedEntityActionTypes,
    sharedPermit: ISharedSitePermit,
    e: React.MouseEvent,
  ): void => {
    const { responsible, projectUrl, locationUrl } = sharedPermit
    switch (actionType) {
      case SharedEntityActionTypes.GO_TO_PROJECT:
        defaultHandlers.handleLinkClick(e, projectUrl)
        break
      case SharedEntityActionTypes.GO_TO_TO_LOCATION:
        defaultHandlers.handleLinkClick(e, locationUrl)
        break
      case SharedEntityActionTypes.CALL_ADMIN:
        defaultHandlers.handleCallTo(responsible?.phoneNumber)
        break
      case SharedEntityActionTypes.MAIL_ADMIN:
        defaultHandlers.handleMailTo(responsible?.email)
        break
    }
  }

  const renderActions = (): JSX.Element => {
    const sharedForm = sharedSitePermitStore.list.find(
      d => d.id === match.params.entityId,
    )
    if (!sharedForm) return null

    return (
      <SharedPermitActions
        entity={sharedForm}
        companyName={sharedForm.companyName}
        onActionClick={handleActionClick}
        projectId={sharedForm.projectFromId}
        isMobile={true}
      />
    )
  }

  const handleBackClick = (): void => {
    common.toggleNavBar()
    common.goBack(common.displayFormsView)
  }

  return (
    <EntitySharedView
      common={common}
      sharedSitePermitStore={sharedSitePermitStore}
      entityId={match.params.entityId}
      onBackClick={handleBackClick}
      renderActions={renderActions}
    />
  )
}

export default withRouter(
  inject('sharedSitePermitStore', 'common')(observer(FormsSharedView)),
)
